import { render, staticRenderFns } from "./scrollBoard.vue?vue&type=template&id=324b501a&"
import script from "./scrollBoard.vue?vue&type=script&lang=js&"
export * from "./scrollBoard.vue?vue&type=script&lang=js&"
import style0 from "./scrollBoard.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports